// @flow
import React, { Component, type Node } from 'react';
import ModalWrapper from 'components/common/ModalWrapper';
import './CategoryEditModal.scss';

type Props = {
  open: boolean,
  children: Node,
  onClose(): void,
  onSave(): Promise<*>,
  onCreate(): void,
};

class CategoryEditModal extends Component<Props> {
  content: any = null;

  render() {
    const { children, open, onClose, onSave, onCreate } = this.props;
    return (
      <ModalWrapper className="CategoryEditModal" open={open}>
        <h2>카테고리 수정</h2>
        <div className="content">{children}</div>
        <div className="foot">
          <div className="button cancel" onClick={onClose}>
            취소
          </div>
          <div className="button save" onClick={onSave}>
            저장
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

export default CategoryEditModal;



// WEBPACK FOOTER //
// ./src/components/write/CategoryEditModal/CategoryEditModal.js